module.exports = __webpack_public_path__ + "img/route_sender_number_1.17168500.png";